import { render, staticRenderFns } from "./MessageNotificationDialog.vue?vue&type=template&id=47074b6c&"
import script from "./MessageNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./MessageNotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports